import useAct from '../useAct'
import './Form.scoped.scss'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import useBrandSettingsTranslate from '../hooks/useBrandSettingsTranslate';
import LanguageSelector from './LanguageSelector';

export default function TextContent() {
  const act = useAct()

  const {
    translated: { privacyPolicy, unsubscribeBlock },
    fallback: { privacyPolicy: fallbackPrivacyPolicy, unsubscribeBlock: fallbackUnsubscribeBlock },
    textContentUpdater,
    flag
  } = useBrandSettingsTranslate()
  const [privacyEditorSourceMode, setPrivacyEditorSourceMode] = useState(false);
  const [unsubscribeEditorSourceMode, setUnsubscribeEditorSourceMode] = useState(false);


  return <div>
    <div className="language-selector">
      <LanguageSelector />
    </div>
    <div className='box form'>
      <h2 className='no-margin-top'>Privacy Policy { flag }</h2>
      <div className="field">
        <p className='small bold dark-grey'>This will be the default privacy policy shown on any pages or surveys you set up.</p>
        <InlineCkEditor
          value={privacyPolicy || ''}
          placeholder={fallbackPrivacyPolicy || ''}
          sourceMode={privacyEditorSourceMode}
          setSourceMode={setPrivacyEditorSourceMode}
          onUpdate={(html) =>textContentUpdater('privacyPolicy', html )}
          mergeTags={[]}
          hideMergeTags
          features={['sourceMode']}
        />
      </div>
    </div>
    <div className='box form'>
      <h2 className='no-margin-top'>Unsubscribe Block { flag }</h2>
      <div className="field">
        <p className='small bold dark-grey'>This text will be added to emails which show an unsubscribe link</p>
        <InlineCkEditor
          value={unsubscribeBlock || ''}
          placeholder={fallbackUnsubscribeBlock || ''}
          sourceMode={unsubscribeEditorSourceMode}
          setSourceMode={setUnsubscribeEditorSourceMode}
          onUpdate={(html) =>textContentUpdater('unsubscribeBlock', html )}
          mergeTags={[]}
          hideMergeTags
          features={['sourceMode']}
        />
      </div>
    </div>
  </div>
};
